export default __webpack_public_path__ + "bf499850a9b2cf34cee6e1f22a9eba54.mp3";